import PublicLayout from "@/components/PublicLayout";
import { Mail, Shield, Globe, ExternalLink } from "lucide-react";

const CONTACTS = [
  {
    icon: Mail,
    label: "General enquiries & support",
    email: "hello@nextrota.com",
    description: "Product help, billing questions, anything else.",
  },
  {
    icon: Shield,
    label: "Privacy & data requests",
    email: "privacy@nextrota.com",
    description: "Data access, deletion or any privacy concern.",
  },
];

export default function ContactPage() {
  return (
    <PublicLayout
      title="Get in touch"
      intro="Need assistance? We'd be happy to help. Drop us a line directly and we'll get back to you as soon as possible - usually within one working day.">

      <div className="not-prose space-y-4">
        {CONTACTS.map(({ icon: Icon, label, email, description }) => (
          <a key={email}
             href={`mailto:${email}`}
             data-testid={`contact-mailto-${email.split("@")[0]}`}
             className="group flex items-start gap-4 p-5 bg-white border border-slate-200 rounded-xl hover:border-[#2563EB] hover:shadow-sm transition-all">
            <span className="grid place-items-center h-11 w-11 rounded-lg bg-[#DBE7FE] text-[#2563EB] shrink-0">
              <Icon className="h-5 w-5" />
            </span>
            <div className="flex-1 min-w-0">
              <div className="eyebrow mb-1">{label}</div>
              <div className="text-lg font-medium text-[#0B1A36] flex items-center gap-1.5 group-hover:text-[#2563EB] transition-colors">
                {email}
                <ExternalLink className="h-3.5 w-3.5 opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
              <p className="text-sm text-[#4B5773] mt-1">{description}</p>
            </div>
          </a>
        ))}

        <div className="flex items-start gap-4 p-5 bg-[#F6F9FE] border border-[#DBE7FE] rounded-xl">
          <span className="grid place-items-center h-11 w-11 rounded-lg bg-white text-[#2563EB] border border-[#DBE7FE] shrink-0">
            <Globe className="h-5 w-5" />
          </span>
          <div>
            <div className="eyebrow mb-1">Website</div>
            <a href="https://nextrota.com" className="text-base font-medium text-[#0B1A36] hover:text-[#2563EB]">
              nextrota.com
            </a>
            <p className="text-sm text-[#4B5773] mt-1">
              For product updates and documentation.
            </p>
          </div>
        </div>
      </div>

      <p className="text-sm text-[#4B5773] mt-10">
        Prefer something else? Sign-in support is available from inside your workspace via the avatar menu in the top-right.
      </p>
    </PublicLayout>
  );
}
